<template src="./Index.html"></template>

<script>
export default {
  components: {},
  created() {
    if (this.$route.query.params != null) {
      this.filters.jobType = this.$route.query.params;

    }
    this.getAll();
    this.$store.dispatch("lookups/getLookups");
    this.$store.dispatch("lookups/getJobGroups");

  },
  computed: {
    jobTypes() {
      return [
        { value: 0, label: "الكل" },
        { value: 1, label: "طبيب" },
        { value: 2, label: "اداري" },
      ]
    },
    administrationTypes() {
      return this.$store.getters["lookups/getLookupByType"](
        this.$lookupTypes.AdministrationTypes
      );
    },
    administrations() {
      return [
        { value: 0, label: "الكل" },
        ...this.$store.state.lookups.administrations,
      ];
    }, 
 
    jobGroups() {
      return [
        { value: 0, label: "الكل" },
        ...this.$store.state.lookups.jobGroups,
      ];
    },
    departments() {
      return this.$store.state.lookups.departments;
    },
    units() {
      return this.$store.state.lookups.units;
    },
    pageCount() {
      return Math.ceil(
        this.totalItems /
        this.filters.pageSize
      );
    },
  },
  data() {
    return {
      subtitle: "",
      items: [
        {
          text: "التقارير",
        },
        {
          text: "تقرير الموظفين حسب نوع الوظيفية ",
        },
      ],
      itemId: 0,
      view: 0,
      data: [],
      totalItems: 0,
      filters: {
        page: 1,
        pageSize: 10,
        jobType: 0,
        jobGroupId: 0,
        // administrationTypeId: null,
        // administrationId: null,
        // departmentId: null,
        // unitId: null,
        // fullName: null,
      },
      headers: [
        {
          text: "الرقم التسلسلي ",
          value: "employeeNo",
          sortable: false,
          align: "start",
        },
        {
          text: "اسم الموظف",
          value: "fullName",
          sortable: false,
          align: "start",
        },
        {
          text: "الوظيفية ",
          value: "jobName",
          sortable: false,
          align: "start",
        },

        // {
        //   text: "الادارة / الفرع",
        //   value: "administration",
        //   sortable: false,
        //   align: "start",
        // },
        // {
        //   text: "القسم ",
        //   value: "department",
        //   sortable: false,
        //   align: "start",
        // },      
        // { text: "مسجل بواسطة", value: "createdBy", sortable: false },
        // { text: "تاريخ التسجيل", value: "createdOn", sortable: false },     
      ],
    };
  },
  methods: {
    changeAdministration() {
      this.filters.departmentId = null;
      this.filters.unitId = null;
      if (this.filters.administrationTypeId != 1002) {
        this.$store.dispatch(
          "lookups/getDepartments",
          this.filters.administrationId
        );
      } else {
        this.$store.dispatch("lookups/getUnitsById", {
          typeId: 1,
          id: this.filters.administrationId,
        });
      }
      this.getAll();
    },
    changeDepartment() {
      this.filters.unitId = null;
      this.$store.dispatch("lookups/getUnitsById", {
        typeId: 2,
        id: this.filters.departmentId,
      });
      this.getAll();
    },
    changeType() {
      this.filters.administrationId = null;
      this.filters.departmentId = null;
      this.filters.unitId = null;
      this.$store.dispatch(
        "lookups/getAdministrationsByType",
        this.filters.administrationTypeId
      );
      this.getAll();
    },
    getAll(page) {
      this.filters.page = page || 1;
      this.$store.dispatch("reports/getEmployeesJobs", this.filters).then((res) => {
        this.data = res.data;
        this.totalItems = res.totalItems;
      });
    },
    download() {
      const paramsString = Object.entries(this.filters)
        .filter(([, val]) => val !== null)
        .map(([key, val]) => `${key}=${val}`)
        .join("&");
      window.open(`/api/reports/EmployeesJobsExcel?${paramsString}`, "_blank");
    },

  },
};
</script>
